// AUTO-GENERATED GraphQL Builder for WhatsAppDevice
import * as Builders from '../';
export class WhatsAppDeviceBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  instanceId(){ return this.add('instanceId'); }
  accountId(){ return this.add('accountId'); }
  phoneNumber(){ return this.add('phoneNumber'); }
  displayName(){ return this.add('displayName'); }
  status(){ return this.add('status'); }
  enabled(){ return this.add('enabled'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }
}
